import { authenticatedFetch } from '../authenticatedFetch';
import { isHostRdr } from '../urls';

let configPromise;

export function getConfig() {
  return configPromise;
}

export function refetchConfig() {
  const URL = isHostRdr() ? '/fc/config' : '/config';
  return (configPromise = authenticatedFetch(URL).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw Error(`Config API responded with HTTP status ${response.status}`);
    }
  }));
}
